import React from 'react';
import styled from '@emotion/styled';

const StatusLabelStyles = styled.div<{ color?: string }>`
  background-color: #fff;
  /* width: 124px; */
  height: 32px;
  font-size: 10px;
  display: flex;
  /* justify-content: center; */
  align-items: center;
  font-weight: 600;
  color: ${(props) => props.color};
  @media (min-width: 768px) {
    /* width: 160px; */
    height: 32px;
    font-size: 14px;
  }
`;
interface Props {
  status: string;
}
const StatusLabel = (props: Props) => {
  return (
    <StatusLabelStyles
      // border={
      //   props.status === 'In Progress'
      //     ? '1px solid #76ADB8'
      //     : props.status === 'Completed'
      //     ? '1px solid #79A666'
      //     : props.status === 'Cancelled'
      //     ? '1px solid #B0B0B0'
      //     : props.status === 'Received'
      //     ? '1px solid #2C6794'
      //     : props.status === 'Requested'
      //     ? '1px solid #D5B03D'
      //     : props.status === 'SDA Requested'
      //     ? '1px solid #EF7458'
      //     : '1px solid #AA94A9'
      // }
      color={
        props.status === 'In Progress'
          ? '#76ADB8'
          : props.status === 'Completed'
          ? '#79A666'
          : props.status === 'Cancelled'
          ? '#B0B0B0'
          : props.status === 'Received'
          ? '#2C6794'
          : props.status === 'Requested'
          ? '#D5B03D'
          : props.status === 'SDA Requested'
          ? '#EF7458'
          : '#AA94A9'
      }
    >
      {props.status}
    </StatusLabelStyles>
  );
};

export default StatusLabel;
